import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as VerifyUserIdentityActions from './verify-user-identity.actions';
import * as VerifyUserIdentityFeature from './verify-user-identity.reducer';
import * as VerifyUserIdentitySelectors from './verify-user-identity.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { act } from '@ngrx/effects';

@Injectable()
export class VerifyUserIdentityFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = toSignal(
    this.store.pipe(
      select(VerifyUserIdentitySelectors.selectVerifyUserIdentityLoaded),
    ),
  );
  loading$ = this.store.pipe(
    select(VerifyUserIdentitySelectors.selectVerifyUserIdentityLoading),
  );
  lastVerifyUserIdentity$ = this.store.pipe(
    select(VerifyUserIdentitySelectors.selectLastVerifyUserIdentity),
  );

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init(password: string) {
    this.store.dispatch(
      VerifyUserIdentityActions.initVerifyUserIdentity({ password }),
    );
  }

  /**
   * Dispatches an action to verify the user's identity.
   *
   * This function is used to initiate the process of verifying the user's identity.
   * It dispatches an action to the store with the provided data and key.
   *
   * @param {Object} action - The action to be dispatched. It should contain a key and optionally some data.
   * @param {any} action.data - The data to be included in the action. This could be any data related to the verification process.
   * @param {string} action.key - The key that identifies the type of action to be performed.
   */
  openVerifyUserIdentity(action: { data?: any; key: string }) {
    // Dispatch the action to the store
    this.store.dispatch(
      VerifyUserIdentityActions.openVerifyUserIdentity({
        action,
      }),
    );
  }
}
